import { IVeriTableHeader, IVeriTableRow } from "@directives/_veri/veriTable/veriTable.component";
import { IDriverFilter } from "@interfaces/filters/IDriverFilter";
import { IGroupFilter } from "@interfaces/filters/IGroupFilter";
import { IDriver } from "@interfaces/IDriver";
import { TranslationService } from "@services/translation.service";
import * as angular from "angular";
import { IFilterBar, IFilterBarFilter } from "../newResourceFilterBar.component";
import "./combinedResourceFilter.component.scss";

interface IComponentBindings {
    selectedDriver: IDriver;
    driverId: number;
    groupFilter: IGroupFilter;
}

class ComponentController implements angular.IComponentController, IComponentBindings, IFilterBarFilter<IDriverFilter> {

    parent: IFilterBar;
    show = false;
    isDirty = false;

    filterName = "CombinedResource";
    filterLabel: string;
    filterTitle: string;
    filterIcon: string;
    showClearFilterButton = true;

    drivers: IDriver[];
    selectedDriver: IDriver;

    driverId: number;

    groupFilter: IGroupFilter;

    previousFilter: IDriverFilter;

    tableHeaders: IVeriTableHeader[];
    tableRows: IVeriTableRow<IDriver>[];

    onChange: (args: { filter: IDriverFilter }) => void;

    static $inject = ["$element", "translationService"];

    constructor(public readonly $element: HTMLElement, private readonly translationService: TranslationService) {
    }

    $onInit() {
        if (parent) {
            this.parent.registerFilter(this);
        }
    }

    $onDestroy() {
        this.show = false;
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        this.updateFilterLabel();

        //if (onChangesObj["driverId"]) {
        //    this.selectedDriver = null;
        //    this.getDrivers();
        //}

        //if (onChangesObj["groupFilter"]) {
        //    this.getDrivers();
        //}
    }

    toggleFilter(show: boolean) {
        this.show = show;

        if (this.show) {
            //this.getDrivers();
        }
    }

    selectedDriverChanged(driver: IDriver) {
    }

    clearFilter() {
        this.selectedDriver = null;
        this.driverId = null;

        this.updateFilterLabel();
    }

    createFilterObject(): IDriverFilter {
        return {
            driver: this.selectedDriver
        };
    }

    // ------------------

    private updateFilterLabel() {
        this.filterLabel = this.translationService.t('filters.combinedResourceFilter.allDrivers');
        this.filterIcon = "person";

        if (this.drivers && this.driverId) {
            this.selectedDriver = this.drivers.find(driver => driver.Id === this.driverId);
        }

        if (this.selectedDriver) {
            this.filterLabel = this.selectedDriver.DisplayName;
        }

        this.isDirty = !!this.selectedDriver;


        this.filterLabel = this.translationService.t('filters.combinedResourceFilter.allResources');
        this.filterIcon = "filter_alt";
    }

}

export class CombinedResourceFilterComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    require: { [index: string]: string; };
    template: string;

    constructor() {
        this.bindings = {
            //selectedDriver: "<driver",
            //driverId: "<?",
            //groupFilter: "<?",

            onChange: "&"
        };

        this.require = {
            parent: "^?newResourceFilterBar"
        };

        this.controller = ComponentController;
        this.template = require("./combinedResourceFilter.component.html");
    }
}
